import { t } from "@/i18n-js/instance";
import { ProgressiveImage } from "@circle-react/components/shared/ProgressiveImage";
import { useAIAgentsLocalizedFeatureImages } from "@circle-react/config/Locales/AIAgentsLocalizedFeatureImages";
import { Blocks } from "../Blocks";
import { localeRoot as communityBotLocale } from "../constants";

const localeRoot = `${communityBotLocale}.blocks.ai_inbox_feature`;

const backgroundColors = {
  primary: "#FFC9D3",
  secondary: "#FFF1F3",
};

interface AIInboxFeatureProps {
  featureNumber: number;
}

export const AIInboxFeature = ({ featureNumber }: AIInboxFeatureProps) => {
  const imageVariants = useAIAgentsLocalizedFeatureImages(featureNumber);

  return (
    <Blocks>
      <Blocks.FeatureSummary backgroundColor={backgroundColors.secondary}>
        <Blocks.Header
          localeRoot={localeRoot}
          iconName="20-ai-inbox"
          backgroundColor={backgroundColors.primary}
        />
        <Blocks.FeatureList>
          <Blocks.FeatureItem backgroundColor={backgroundColors.primary}>
            {t([localeRoot, "features", "0"])}
          </Blocks.FeatureItem>
          <Blocks.FeatureItem backgroundColor={backgroundColors.primary}>
            {t([localeRoot, "features", "1"])}
          </Blocks.FeatureItem>
          <Blocks.FeatureItem backgroundColor={backgroundColors.primary}>
            {t([localeRoot, "features", "2"])}
          </Blocks.FeatureItem>
        </Blocks.FeatureList>
      </Blocks.FeatureSummary>
      <Blocks.FeaturePreview
        backgroundColor={backgroundColors.primary}
        className="flex flex-col items-center justify-center p-8"
      >
        {imageVariants && (
          <ProgressiveImage
            src={imageVariants.large}
            srcVariants={imageVariants}
            alt={t([localeRoot, "image_alt"])}
            className="w-[300px] md:w-auto"
          />
        )}
      </Blocks.FeaturePreview>
    </Blocks>
  );
};
